import * as types from '../../routes/types';

export const routeSearch = () => ({
  type: types.ROUTE_SEARCH,
  payload: {},
});

export const routeSearchQueryText = (queryText, query) => ({
  type: types.ROUTE_SEARCH_QUERY_TEXT,
  payload: {
    queryText,
  },
  query,
});



// WEBPACK FOOTER //
// ./src/actions/search/routes.js